export default "__VITE_ASSET__phoJr$Cn__"